import React, { useState } from 'react';
import MonthCalendarSelector from './MonthCalendarSelector';

export default function BulkTimingsModal({ onClose, onSave }) {
    const [timingBlocks, setTimingBlocks] = useState([
        { id: 1, type: 'Day', startTime: '09:00', endTime: '17:00', is24Hour: false, active: true }
    ]);
    const [selectedDates, setSelectedDates] = useState([]);

    const handleToggleDate = (dateStr) => {
        if (selectedDates.includes(dateStr)) {
            setSelectedDates(selectedDates.filter(d => d !== dateStr));
        } else {
            setSelectedDates([...selectedDates, dateStr]);
        }
    };

    const handleCreate = () => {
        if (selectedDates.length === 0) {
            alert('Please select at least one date.');
            return;
        }
        const activeBlocks = timingBlocks.filter(b => b.active);
        if (activeBlocks.length === 0) {
            alert('Please enable at least one timing block.');
            return;
        }
        
        // Pass data back up to be saved to firestore
        onSave(selectedDates, activeBlocks);
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Bulk create shifts</h2>
                    <p style={styles.subtitle}>Add up to 3 timing groups. Each group can be applied to selected dates. Conflicts are checked against shifts and leave.</p>
                </div>
                
                <div style={styles.content}>
                    <div style={styles.timingBlock}>
                        <div style={styles.timingHeader}>
                            <span style={{ fontWeight: '600', fontSize: '14px' }}>Timing 1</span>
                            <input 
                                type="checkbox" 
                                checked={timingBlocks[0].active} 
                                onChange={(e) => setTimingBlocks([{...timingBlocks[0], active: e.target.checked}])}
                            />
                        </div>
                        
                        <div style={styles.inputRow}>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Shift type</label>
                                <select 
                                    style={styles.input}
                                    value={timingBlocks[0].type}
                                    onChange={(e) => setTimingBlocks([{...timingBlocks[0], type: e.target.value}])}
                                >
                                    <option value="Day">Day</option>
                                    <option value="Night">Night</option>
                                    <option value="Live-in">Live-in</option>
                                </select>
                            </div>
                            
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Start</label>
                                <input 
                                    type="time" 
                                    style={styles.input}
                                    value={timingBlocks[0].startTime}
                                    onChange={(e) => setTimingBlocks([{...timingBlocks[0], startTime: e.target.value}])}
                                />
                            </div>
                            
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>End</label>
                                <input 
                                    type="time" 
                                    style={styles.input}
                                    value={timingBlocks[0].endTime}
                                    onChange={(e) => setTimingBlocks([{...timingBlocks[0], endTime: e.target.value}])}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontSize: '14px', color: '#374151' }}>24 hours</span>
                            <input 
                                type="checkbox" 
                                checked={timingBlocks[0].is24Hour}
                                onChange={(e) => setTimingBlocks([{...timingBlocks[0], is24Hour: e.target.checked}])}
                            />
                        </div>
                        
                        {/* Calendar */}
                        <div style={{ marginTop: '24px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                            <MonthCalendarSelector 
                                selectedDates={selectedDates} 
                                onToggleDate={handleToggleDate} 
                            />
                        </div>
                    </div>
                </div>

                <div style={styles.footer}>
                    <button onClick={onClose} style={styles.cancelBtn}>Cancel</button>
                    <button onClick={handleCreate} style={styles.createBtn}>Review and create</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 1000
    },
    modal: {
        backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '600px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
    },
    header: {
        padding: '24px', borderBottom: '1px solid #e5e7eb'
    },
    title: {
        margin: 0, fontSize: '20px', color: '#111827', fontWeight: 'bold'
    },
    subtitle: {
        margin: '8px 0 0 0', fontSize: '14px', color: '#6b7280'
    },
    content: {
        padding: '24px', overflowY: 'auto', flex: 1
    },
    timingBlock: {
        border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', marginBottom: '16px'
    },
    timingHeader: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'
    },
    inputRow: {
        display: 'flex', gap: '12px'
    },
    inputGroup: {
        flex: 1, display: 'flex', flexDirection: 'column', position: 'relative'
    },
    label: {
        position: 'absolute', top: '-8px', left: '8px', backgroundColor: 'white', 
        padding: '0 4px', fontSize: '11px', color: '#6b7280'
    },
    input: {
        padding: '12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none'
    },
    footer: {
        padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '12px'
    },
    cancelBtn: {
        padding: '8px 16px', border: 'none', background: 'none', color: '#2563eb', fontWeight: '500', cursor: 'pointer'
    },
    createBtn: {
        padding: '8px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '500', cursor: 'pointer'
    }
};
